import { render, staticRenderFns } from "./SegmentRefresh.vue?vue&type=template&id=83c55d14&"
import script from "./SegmentRefresh.vue?vue&type=script&lang=js&"
export * from "./SegmentRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports